<template>
  <base-card
    v-if="upcoming.length"
    class="notification"
  >
    <base-text light>
      You have <strong>{{ upcoming.length }} upcoming
        appointment{{ upcoming.length === 1 ? '' : 's' }}</strong> in the next 24 hours:
      <ul>
        <li
          v-for="(item, index) in upcoming"
          :key="`upcoming_${index}`"
        >
          {{ item.subject }} on {{ item.start_date | nicedate('custom', 'MMMM DD, YYYY [at] hh:mma zz') }}
        </li>
      </ul>
    </base-text>
  </base-card>
</template>

<script>
export default {

  name: 'AppointmentsNotification',
  props: {
    upcoming: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
.notification {
  background-color: #F2CEB1;
  color: $black !important;
  font-size: 14px;
}
::v-deep .card-body {
  padding: 12px 14px;
}
</style>
